!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.index = t() : e.index = t();
}(global, function () {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 2);
  }([function (e, t) {
    e.exports = require("react");
  }, function (e, t) {
    e.exports = require("papaparse");
  }, function (e, t, n) {
    e.exports = n(7);
  }, function (e, t, n) {
    var r = n(4),
      o = n(5);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var i = {
        insert: "head",
        singleton: !1
      },
      a = (r(o, i), o.locals ? o.locals : {});
    e.exports = a;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = function o() {
        return void 0 === r && (r = Boolean(window && document && document.all && !window.atob)), r;
      },
      i = function () {
        var e = {};
        return function (t) {
          if (void 0 === e[t]) {
            var n = document.querySelector(t);
            if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
              n = n.contentDocument.head;
            } catch (e) {
              n = null;
            }
            e[t] = n;
          }
          return e[t];
        };
      }(),
      a = [];
    function u(e) {
      for (var t = -1, n = 0; n < a.length; n++) if (a[n].identifier === e) {
        t = n;
        break;
      }
      return t;
    }
    function c(e, t) {
      for (var n = {}, r = [], o = 0; o < e.length; o++) {
        var i = e[o],
          c = t.base ? i[0] + t.base : i[0],
          f = n[c] || 0,
          s = "".concat(c, " ").concat(f);
        n[c] = f + 1;
        var l = u(s),
          d = {
            css: i[1],
            media: i[2],
            sourceMap: i[3]
          };
        -1 !== l ? (a[l].references++, a[l].updater(d)) : a.push({
          identifier: s,
          updater: b(d, t),
          references: 1
        }), r.push(s);
      }
      return r;
    }
    function f(e) {
      var t = document.createElement("style"),
        r = e.attributes || {};
      if (void 0 === r.nonce) {
        var o = n.nc;
        o && (r.nonce = o);
      }
      if (Object.keys(r).forEach(function (e) {
        t.setAttribute(e, r[e]);
      }), "function" == typeof e.insert) e.insert(t);else {
        var a = i(e.insert || "head");
        if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        a.appendChild(t);
      }
      return t;
    }
    var s,
      l = (s = [], function (e, t) {
        return s[e] = t, s.filter(Boolean).join("\n");
      });
    function d(e, t, n, r) {
      var o = n ? "" : r.media ? "@media ".concat(r.media, " {").concat(r.css, "}") : r.css;
      if (e.styleSheet) e.styleSheet.cssText = l(t, o);else {
        var i = document.createTextNode(o),
          a = e.childNodes;
        a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(i, a[t]) : e.appendChild(i);
      }
    }
    function p(e, t, n) {
      var r = n.css,
        o = n.media,
        i = n.sourceMap;
      if (o ? e.setAttribute("media", o) : e.removeAttribute("media"), i && btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), e.styleSheet) e.styleSheet.cssText = r;else {
        for (; e.firstChild;) e.removeChild(e.firstChild);
        e.appendChild(document.createTextNode(r));
      }
    }
    var v = null,
      m = 0;
    function b(e, t) {
      var n, r, o;
      if (t.singleton) {
        var i = m++;
        n = v || (v = f(t)), r = d.bind(null, n, i, !1), o = d.bind(null, n, i, !0);
      } else n = f(t), r = p.bind(null, n, t), o = function o() {
        !function (e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(n);
      };
      return r(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else o();
      };
    }
    e.exports = function (e, t) {
      (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = o());
      var n = c(e = e || [], t);
      return function (e) {
        if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
          for (var r = 0; r < n.length; r++) {
            var o = u(n[r]);
            a[o].references--;
          }
          for (var i = c(e, t), f = 0; f < n.length; f++) {
            var s = u(n[f]);
            0 === a[s].references && (a[s].updater(), a.splice(s, 1));
          }
          n = i;
        }
      };
    };
  }, function (e, t, n) {
    (e.exports = n(6)(!1)).push([e.i, "a {\n  color: inherit;\n  text-decoration: inherit;\n}", ""]);
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var n = function (e, t) {
            var n = e[1] || "",
              r = e[3];
            if (!r) return n;
            if (t && "function" == typeof btoa) {
              var o = (a = r, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a)))) + " */"),
                i = r.sources.map(function (e) {
                  return "/*# sourceURL=" + r.sourceRoot + e + " */";
                });
              return [n].concat(i).concat([o]).join("\n");
            }
            var a;
            return [n].join("\n");
          }(t, e);
          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" == typeof e && (e = [[null, e, ""]]);
        for (var r = {}, o = 0; o < this.length; o++) {
          var i = this[o][0];
          "number" == typeof i && (r[i] = !0);
        }
        for (o = 0; o < e.length; o++) {
          var a = e[o];
          "number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), t.push(a));
        }
      }, t;
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(1),
      o = n.n(r),
      i = n(0),
      a = n.n(i),
      u = function u(e) {
        var t = e.data,
          n = e.fileName,
          r = e.withTimeStamp,
          u = e.skipHeader,
          c = void 0 !== u && u,
          f = e.skipEmptyLines,
          s = void 0 !== f && f,
          l = e.children,
          d = e.onClick,
          p = null;
        Object(i.useEffect)(function () {
          return function () {
            b();
          };
        }, []);
        var v = Object(i.useCallback)(function () {
            return r ? n + "_" + Date.now() : n;
          }, [n, r]),
          m = function m(e) {
            b();
            var t = new Blob([e], {
              type: "text/csv"
            });
            return p = URL.createObjectURL(t);
          },
          b = function b() {
            p && (URL.revokeObjectURL(p), p = null);
          };
        return a.a.createElement("a", {
          href: "#",
          target: "_self",
          onClick: function onClick(e) {
            var n = o.a.unparse(t, {
                header: !c,
                skipEmptyLines: s
              }),
              r = m(n),
              i = v(),
              a = document.createElement("a");
            a.href = r, a.download = i, a.target = "_blank", a.click(), a.remove(), d && d(), e.stopPropagation(), e.preventDefault();
          }
        }, l);
      };
    n(3), t.default = u;
  }]);
});